module.exports = __webpack_public_path__ + "img/cv.8593df07.svg";